<script setup>
import { computed, onMounted } from 'vue';
import { useCamerasStore } from '@/store/cameras';
import BaseChart from '@/components/charts/BaseChart.vue';

const props = defineProps({
  height: { type: Number, default: 400 },
  options: { type: Object, default: () => {} },
  cameraIds: { type: Array, default: () => [] },
  chartType: { type: String, default: 'line' },
  dataLoader: { type: Function, default: async function () {} },
  title: { type: String, default: '' },
  subtitle: { type: String, default: '' },
  disableControlRow: { type: Boolean, default: false },
  hideTimeResolution: { type: Boolean, default: false },
  defaultCollapsed: { type: Boolean, default: false },
  incidentAnnotationProviders: { type: Array, default: () => [] },
})

const localCameraIds = computed(() => {
  if (props.cameraIds.length > 0) return props.cameraIds
  if(!cameras.value) return []
  return Object.values(cameras.value).map(({ cameraId }) => cameraId)
})

const cameras = computed(() => useCamerasStore().getNonDecommissionedCameras())

const camerasLoaded = computed(() => cameras.value)

async function localDataLoader(timeSetup, abortSignal) {
  return await props.dataLoader(localCameraIds.value, timeSetup, abortSignal)
}

onMounted(async () => {
  await useCamerasStore().keepCamerasLoaded()
})
</script>

<template>
  <BaseChart
    v-if="camerasLoaded && localCameraIds.length > 0"
    :default-collapsed="props.defaultCollapsed"
    :height="height"
    :data-loader="localDataLoader"
    :chart-type="chartType"
    :options="options"
    :disable-control-row="props.disableControlRow"
    :hide-time-resolution="props.hideTimeResolution"
    :title="title"
    :subtitle="subtitle"
    :incident-annotation-providers="incidentAnnotationProviders"
  />
</template>

<style scoped>

</style>
